module.exports = __webpack_public_path__ + "img/@2x_.a07763f6.svg";